import React from "react";

export default function Casestudybanner() {
  return (
    <section className="relative w-full overflow-hidden bg-black">
      <div className="flex flex-col xl-custom:hidden">
        <div className="relative w-full overflow-hidden">
          <img
            src="/uploads/CaseStudy/Banner_casestudy.webp"
            alt="Mobile Image"
            className="w-full h-auto object-contain"
          />
        </div>
        <div className="px-4 py-8 text-white text-left">
          <h1 className="font-uber text-[28px] font-bold leading-[36px] sm:text-[32px] sm:leading-[40px]">
            Case Study
          </h1>
          <p className="mt-2 text-current font-uber text-[16px] font-normal leading-[24px] max-w-md">
            Transforming customer engagement into action through playable experiences
          </p>
        </div>
      </div>

      <div className="relative w-full min-h-screen hidden xl-custom:flex xl-custom:items-center">
        <img
          src="/uploads/CaseStudy/Banner_casestudy.webp"
          alt="Background"
          className="absolute inset-0 w-full h-full object-contain z-0" 
        />

        <div className="relative z-10 mx-auto max-w-6xl px-6 py-14 w-full">
          <div className="w-full md:w-5/12 text-white text-center md:text-left">
            <h1 className="font-uber text-[28px] font-bold leading-[36px] sm:text-[32px] sm:leading-[40px] xl-custom:text-[36px] xl-custom:leading-[44px]">
              Case Study
            </h1>
            <p className="mt-2 text-current font-uber text-[16px] font-normal leading-[24px] max-w-md">
              Transforming customer engagement into action through playable experiences
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}